import { render, staticRenderFns } from "./SkupStavkaBase.vue?vue&type=template&id=ed20f51c&scoped=true&"
import script from "./SkupStavkaBase.vue?vue&type=script&lang=js&"
export * from "./SkupStavkaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed20f51c",
  null
  
)

export default component.exports